import { getStore } from '@/base/store/storeRegistry'

/**
 * Guard trasy /payer-paywall (beforeEnter).
 * Uruchamia się przy każdej nawigacji do widoku, w tym przy Wstecz/Dalej (popstate),
 * zanim komponent się zamontuje.
 *
 * Zabezpiecza przed:
 *  - wejściem bez danych transakcji (odświeżenie / deep-link) -> ErrorNotFound,
 *  - powrotem na formularz po jego zatwierdzeniu (Back po submicie) -> powrót do paywalla,
 *  - wejściem na payer-paywall dla transakcji bez flagi isPayerPaywall -> powrót do paywalla.
 *
 * @param {import('vue-router').RouteLocationNormalized} to
 * @param {import('vue-router').RouteLocationNormalized} from
 * @param {import('vue-router').NavigationGuardNext} next
 */
export function payerPaywallGuard(to, from, next) {
  const state = getStore().state.payment
  const fallback = state.payerPaywallReturn ?? { name: 'Start', params: { apiToken: state.apiToken } }

  // 1) brak danych (odświeżenie / deep-link) -> nie ma czego wznawiać
  if (!state.paymentData) {
    return next({ name: 'ErrorNotFound' })
  }
  // 2) krok już ukończony (Back po submicie) -> do przodu, na paywall
  if (state.payerPaywallCompleted) {
    return next(fallback)
  }
  // 3) transakcja bez flagi payer-paywall -> nie powinno tu trafić
  if (!state.paymentData.isPayerPaywall) {
    return next(fallback)
  }
  return next()
}
